<template>
  <div class="circle-progress" :style="{ width: size + 'px', height: size + 'px' }">
    <svg :width="size" :height="size" viewBox="0 0 100 100">
      <!-- 背景圆 -->
      <circle
        cx="50"
        cy="50"
        r="45"
        fill="none"
        stroke="#112F62"
        :stroke-width="strokeWidth"
      />
      <!-- 进度圆 -->
      <circle
        cx="50"
        cy="50"
        r="45"
        fill="none"
        :stroke="color"
        :stroke-width="strokeWidth"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="progressOffset"
        class="progress-circle"
      />
    </svg>
    <!-- 百分比文字 -->
    <!-- <div class="percentage">
      {{ percentage }}%
    </div> -->
    <!-- 其他内容 -->
    <div class="info">
      <p v-if="info.tip" class="tip">{{info.tip}}</p>
      <div class="main" v-else>
        <h3 :style="{color: color}">{{info.compared}}</h3>
        <p>{{info.average}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircleProgress',
  props: {
    // 当前百分比 (0-100)
    value: {
      type: [Number, String],
      default: 0,
      validator: v => v >= 0 && v <= 100
    },
    // 圆环大小
    size: {
      type: Number,
      default: 100
    },
    // 线条粗细
    strokeWidth: {
      type: Number,
      default: 8
    },
    // 颜色
    color: {
      type: String,
      default: '#409eff'
    },
    info: {
      type: Object,
      default: {}
    }
  },
  computed: {
    percentage() {
      return Math.round(this.value);
    },
    radius() {
      return 45; // 对应 viewBox 中 r="45"
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    progressOffset() {
      return this.circumference * (1 - this.value / 100);
    }
  }
};
</script>

<style lang="less" scoped>
.circle-progress {
  position: relative;
  display: inline-block;
}

svg {
  transform: rotate(-90deg); /* 从顶部开始 */
  transition: stroke-dashoffset 0.3s ease;
}

.progress-circle {
  transition: stroke-dashoffset 0.5s ease;
}

.percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 37px;
  color: #fff;
  font-weight: 700;
}
.info{
  position: absolute;
  width: 100%;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  .tip{
    font-size: 31px;
    line-height: 45px;
  }
  .main{
    font-size: 37px;
    h3{
      font-size: 43px;
    font-weight: 700;
    }
  }
}
</style>